module.exports = __webpack_public_path__ + "static/media/lon_sit_spe_met.4e11fc43.png";